import { render } from "./autograph.vue?vue&type=template&id=61a9477a"
import script from "./autograph.vue?vue&type=script&lang=js"
export * from "./autograph.vue?vue&type=script&lang=js"

import "./autograph.vue?vue&type=style&index=0&id=61a9477a&lang=css"

import exportComponent from "C:\\Project\\VuePro\\guifanyuanyuanxing\\baiwenbida-index\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__